<template>
  <div class="fts-activity-design-inline">
    <!-- display -->
    <div
      class="activity-inline-display"
      :class="{'activity-inline-display--navi': navigatable}"
    >
      <!-- navigatable -->
      <fts-tippy content="go to activity" v-if="navigatable">
        <fts-label-group
          slot="trigger"
          :item="activity"
          :item-id="activityId"
          :list="list"
          emoji
          :label-color="activity.color"
          @click.native="navigate"
        />
      </fts-tippy>
      <!-- default -->
      <fts-label-group
        :item="activity"
        :item-id="activityId"
        :list="list"
        emoji
        :label-color="activity.color"
        v-else
      />
    </div>
  </div>
</template>

<script>

import FTSTippy from "../elements/FTSTippy";
import FTSLabelGroup from "../elements/FTSLabelGroup";

export default {
  components: {
    "fts-tippy": FTSTippy,
    "fts-label-group": FTSLabelGroup,
  },
  props: {
    navigatable: {
      Boolean,
      default: true,
    },
    activity: Object,
    activityId: [String, Number],
    list: Array,
  },
  methods: {
    navigate() {
      this.$emit("navigate", this.getActivityId);
    },
  },
  computed: {
    getActivityId() {
      return this.activity && this.activity.id ? this.activity.id : this.activityId;
    },
  },
}
</script>

<style lang="scss" scoped>
.fts-activity-design-inline {
  min-width: 0;
  .activity-inline-display {
    max-width: 100%;
    display: inline-flex;
    align-items: center;
  }
}
</style>

<style lang="scss">
.fts-activity-design-inline {
  .activity-inline-display {
    &.activity-inline-display--navi {
      .fts-label-group:hover {
        transform: scale(1.075);
        transition: transform .3s ease-in-out;
        cursor: pointer;
      }
    }
  }
}
</style>